import IcBuilding from "@/assets/icons/ic-building-4.svg";
import IcLuggage from "@/assets/icons/ic-luggage-03.svg";
import IcCalendar from "@/assets/icons/ic-calendar-inquiry-02.svg";
import { formatDate, getCategoryBadgeStyleAgentDetail } from "@/lib/utils";

interface AgentDetailData {
  name: string;
  short_description: string | null;
  provider: string | null;
  application_area: string | null;
  created_at: string;
  solution: string | null;
  main_category?: string | null;
  categories: string | null;
}

interface AgentDetailContentProps {
  agent: AgentDetailData;
}

const MAIN_CATEGORY_LABELS: Record<string, string> = {
  horizontal: "Horizontal (General/Business Support)",
  vertical: "Vertical (Industry-Specific)",
  enabler: "Enabler (Platform/Infrastructure)",
};

export function AgentDetailContent({ agent }: AgentDetailContentProps) {
  return (
    <>
      {/* Agent Info Card */}
      <div className="flex flex-col justify-center gap-6 p-4 md:p-6 rounded w-full border border-black/10">
        <div className="flex flex-col gap-3 w-full">
          <div className="flex flex-col justify-center gap-1">
            <h2 className="text-[30px] md:text-[32px] font-normal leading-9 md:leading-10 tracking-[-0.03em] text-[#000000] break-all">
              {agent.name}
            </h2>
            <p className="text-sm leading-5 tracking-[-0.01em] text-[#000000] whitespace-pre-line break-words">
              {agent.short_description}
            </p>
          </div>

          <div className="w-full h-px bg-black/[0.09] my-1" />

          <div className="flex flex-col gap-3 md:flex-row md:justify-between w-full">
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 w-[84px] md:w-auto shrink-0">
                <img src={IcBuilding} alt="" className="w-5 h-5" />
                <span className="text-sm leading-5 tracking-[-0.01em] text-[#000000]">공급사</span>
              </div>
              <span className="text-base leading-6 tracking-[-0.01em] text-[#000000] md:ml-1 md:max-w-[350px] break-all">
                {agent.provider}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 w-[84px] md:w-auto shrink-0">
                <img src={IcLuggage} alt="" className="w-5 h-5" />
                <span className="text-sm leading-5 tracking-[-0.01em] text-[#000000]">
                  적용 분야
                </span>
              </div>
              <span className="text-base leading-6 tracking-[-0.01em] text-[#000000] md:ml-1 md:max-w-[350px] whitespace-pre-line break-words">
                {agent.application_area}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex items-center gap-2 w-[84px] md:w-auto shrink-0">
                <img src={IcCalendar} alt="" className="w-5 h-5" />
                <span className="text-sm leading-5 tracking-[-0.01em] text-[#000000]">등록일</span>
              </div>
              <span className="text-base leading-6 tracking-[-0.01em] text-[#000000] md:ml-1">
                {formatDate(agent.created_at, "YYYY-MM-DD")}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex flex-col md:flex-row gap-6 w-full">
        {/* 솔루션 개요 */}
        <div className="flex flex-col gap-3 w-full md:w-[717px]">
          <div className="flex flex-col gap-3 p-4 md:p-6 rounded border border-black/10">
            <h3 className="text-xl font-bold leading-7 tracking-[-0.02em] text-[#000000]">
              솔루션 개요
            </h3>
            <p className="text-sm leading-5 tracking-[-0.01em] text-[#000000] whitespace-pre-line break-all">
              {agent.solution}
            </p>
          </div>
        </div>

        {/* Right column: 대분류 + 기능 카테고리 */}
        <div className="flex flex-col gap-6 w-full md:max-w-[379px]">
          {agent.main_category && (
            <div className="flex flex-col gap-3 p-4 md:p-5 rounded border border-black/10">
              <h3 className="text-lg font-bold leading-6 tracking-[-0.01em] text-[#000000]">
                대분류
              </h3>
              <span className="inline-flex items-center text-sm leading-5  text-[#000000] w-fit whitespace-pre-line break-all">
                {agent.main_category}
              </span>
            </div>
          )}

          <div className="flex flex-col gap-3 p-4 md:p-5 rounded border border-black/10">
            <h3 className="text-lg font-bold leading-6 tracking-[-0.01em] text-[#000000]">
              기능 카테고리
            </h3>
            <div className="flex flex-wrap gap-2 text-black whitespace-pre-line break-all">
              {agent.categories}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
